import React, { useState, useEffect } from "react";
import countries from "../../resources/country.json";
import "../../styles/TicketForm.scss";

interface Country {
  code: string;
  label: string;
  phone: string;
  nationality: string;
}

interface Props {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
}

const TicketForm: React.FC<Props> = ({ formData, setFormData }) => {
  const [selectedCountry, setSelectedCountry] = useState<Country | null>(null);
  const [selectedCode, setSelectedCode] = useState<Country | null>(null);

  useEffect(() => {
    if (selectedCountry) {
      setFormData((prev: any) => ({
        ...prev,
        nationality: selectedCountry.nationality,
        country: selectedCountry.label,
      }));
    }
  }, [selectedCountry, setFormData]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;

    setFormData((prev: any) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = countries.find((c) => c.label === e.target.value);

    setSelectedCountry(selected || null);

    setFormData((prev: any) => ({
      ...prev,
      country: e.target.value,
    }));
  };

  const handleCodeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = countries.find((c) => c.phone === e.target.value);
    setSelectedCode(selected || null);
  };

  return (
    <form className="ticket-form">
      <h4>Main Delegate Information</h4>

      <div className="form-row">
        <label>Family Name *</label>
        <input
          type="text"
          name="familyName"
          value={formData.familyName || ""}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-row">
        <label>Given Name *</label>
        <input
          type="text"
          name="givenName"
          value={formData.givenName || ""}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-row">
        <label>Contact Number *</label>

        <div className="contact-row">
          <select
            name="countryCode"
            value={selectedCode ? selectedCode.phone : ""}
            onChange={handleCodeChange}
            className="country-code-select"
            required
          >
            <option value="">Country Code</option>

            {countries.map((c) => (
              <option key={c.code} value={c.phone}>
                +{c.phone} ({c.label})
              </option>
            ))}
          </select>

          <input
            type="text"
            name="contactNumber"
            value={formData.contactNumber || ""}
            onChange={handleChange}
            placeholder="Enter phone number"
            required
          />
        </div>
      </div>

      <div className="form-row">
        <label>Mailing Address *</label>
        <input
          type="text"
          name="mailingAddress"
          value={formData.mailingAddress || ""}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-row">
        <label>Email *</label>
        <input
          type="email"
          name="email"
          value={formData.email || ""}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-row">
        <label>Passport No.</label>
        <input
          type="text"
          name="passportNo"
          value={formData.passportNo || ""}
          onChange={handleChange}
        />
      </div>

      <div className="form-row">
        <label>Insurance Company *</label>
        <input
          type="text"
          name="insuranceCompany"
          value={formData.insuranceCompany || ""}
          onChange={handleChange}
          required
        />
      </div>

      {/* Birthdate */}
      <div className="form-row">
        <label>Birthdate *</label>
        <input
          type="date"
          name="birthdate"
          value={formData.birthdate || ""}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-row">
        <label>Country *</label>
        <select
          name="country"
          value={formData.country || ""}
          onChange={handleCountryChange}
          className="country-select"
          required
        >
          <option value="">Select Country</option>

          {countries.map((country) => (
            <option key={country.code} value={country.label}>
              {country.label}
            </option>
          ))}
        </select>
      </div>

      <div className="form-row">
        <label>Nationality *</label>
        <input
          type="text"
          name="nationality"
          value={formData.nationality || ""}
          onChange={handleChange}
          required
        />
      </div>

      <div className="form-row">
        <label>Note</label>
        <textarea
          name="note"
          value={formData.note || ""}
          onChange={handleChange}
          placeholder="Optional note..."
          style={{
            resize: "none",
            height: "100px",
            width: "100%",
          }}
        />
      </div>
    </form>
  );
};

export default TicketForm;